export const EXPERIMENTAL_FLAG = 'experimental';

export const ACCEPTED_MIME_TYPES = [
  'image/jpg',
  'image/jpeg',
  'image/png',
  'image/apng',
  'image/gif',
  'image/webp',
  'image/avif'
];

// API Configuration
export const API_TIMEOUT = 30000; // 30 seconds
export const API_RETRY_COUNT = 3;
export const TOKEN_REFRESH_BUFFER = 5 * 60 * 1000; // 5 minutes before expiry

// Scan Configuration
export const SCAN_RATE_LIMIT = 1000; // milliseconds between scans

// UI Timing
export const ALERT_DURATION = 5000; // milliseconds
export const DEBOUNCE_DELAY = 250; // milliseconds
export const SETTINGS_DEBOUNCE = 500; // milliseconds

// Storage Keys
export const STORAGE_KEYS = {
  CLIENT_ID: 'clientId',
  DOSSIER_ID: 'dossierId',
  TOKEN: 'barcode-scanner/api-token',
  TOKEN_EXPIRY: 'barcode-scanner/api-token-expiry',
  SETTINGS: 'barcode-scanner/settings',
  HISTORY: 'barcode-scanner/history'
};

// Error Messages (French)
export const ERROR_MESSAGES = {
  NETWORK_ERROR: 'Erreur de connexion. Veuillez vérifier votre connexion internet.',
  TIMEOUT_ERROR: 'La requête a expiré. Veuillez réessayer.',
  AUTH_ERROR: 'Session expirée. Veuillez vous reconnecter.',
  PRODUCT_NOT_FOUND: 'Produit non trouvé.',
  CLIENT_NOT_FOUND: 'Client non trouvé.',
  DOSSIER_NOT_FOUND: 'Dossier non trouvé.',
  DOSSIER_CREATE_ERROR: 'Erreur lors de la création du dossier.',
  DOSSIER_UPDATE_ERROR: 'Erreur lors de la mise à jour du dossier.',
  DOSSIER_MISMATCH: 'Le dossier est associé à un autre client.',
  VALIDATION_REQUIRED: "Veuillez d'abord valider un client.",
  INVALID_RESPONSE: 'Réponse du serveur invalide.',
  EMPTY_RESPONSE: 'Le serveur a retourné une réponse vide.',
  EMPTY_CLIENT_ID: 'Veuillez entrer un numéro de client.',
  EMPTY_DOSSIER_ID: 'Veuillez entrer un numéro de dossier.',
  MISSING_DOSSIER_PRODUCT_ID: 'ID de produit de dossier non trouvé.',
  CONFIRM_DELETE_PRODUCT: 'Êtes-vous sûr de vouloir supprimer ce produit ?',
  CONFIRM_EDIT_CUSTOMER: 'Êtes-vous sûr de vouloir modifier le numéro de client ?',
  CONFIRM_EDIT_DOSSIER: 'Êtes-vous sûr de vouloir modifier le numéro de dossier ?',
  CONFIRM_END_SESSION: 'Êtes-vous sûr de vouloir terminer la session de scan en cours ?',
  SCAN_ERROR: 'Erreur lors du scan. Veuillez réessayer.',
  CAMERA_PERMISSION_DENIED: "Permission d'accès à la caméra refusée.",
  CAMERA_NOT_FOUND: 'Aucune caméra trouvée.',
  UNKNOWN_ERROR: 'Une erreur inattendue est survenue.'
};
